<template>
  <div class="calendario">
    <BotaoPadrao
      arredondadoEsquerda
      class="botao-cenario"
      nome="Calendário de Obrigações"
      icone="calendar-alt"
      :click="abreCalendario"
    />
  </div>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "CalendarioObrigacoes",
  components: {
    BotaoPadrao
  },
  methods: {
    abreCalendario() {
      window.open("http://www.econeteditora.com.br/obrigacoes/", "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.calendario {
  margin: 20px 2rem 0 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
</style>
